var React = require('react');

function Medal132px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M27.724 6.825a.908.908 0 0 1-.008.37.965.965 0 0 1-.063.195c-.012.028-.012.059-.027.087L21.542 18.42c.81 1.387 1.257 2.941 1.257 4.555 0 4.958-3.999 8.993-8.915 8.993-4.916 0-8.915-4.035-8.915-8.993 0-1.615.448-3.17 1.257-4.555L.143 7.477C.127 7.449.127 7.418.115 7.39a.962.962 0 0 1-.062-.195.883.883 0 0 1-.009-.37.938.938 0 0 1 .053-.195c.011-.029.009-.06.023-.089L3.092.546c.011-.023.036-.033.049-.055a.978.978 0 0 1 .253-.283.81.81 0 0 1 .109-.075.968.968 0 0 1 .38-.12c.022-.002.039-.018.061-.019.009-.001.016.002.025.002l.009-.002h19.317c.101 0 .194.029.286.058.082-.018.156-.061.243-.058.363.013.69.225.852.552l2.972 5.995c.014.029.012.06.024.089a.935.935 0 0 1 .052.195zM13.884 29.97c3.823 0 6.934-3.138 6.934-6.995a7.023 7.023 0 0 0-1.231-3.98 6.934 6.934 0 0 0-4.259-2.867 7.183 7.183 0 0 0-2.9.003 6.93 6.93 0 0 0-4.247 2.865 7.023 7.023 0 0 0-1.231 3.979c0 3.857 3.111 6.995 6.934 6.995zm1.126-15.885l3.554-6.098h-9.36l3.541 6.076c.759-.096 1.515-.069 2.265.022zM2.127 6.961l5.406 9.724a8.984 8.984 0 0 1 3.215-2.104L4.049 3.085 2.127 6.961zm5.912-.972h11.69l2.329-3.997H5.71l2.329 3.997zm15.68-2.904l-6.688 11.477a8.945 8.945 0 0 1 3.206 2.121l5.404-9.722-1.922-3.876z","key":1})]);
}

Medal132px.displayName = "Medal132px";

Medal132px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 27.75 31.97"};

module.exports = Medal132px;

Medal132px.default = Medal132px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/medal-1-32px.svg
// module id = 1106
// module chunks = 0